import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.div`
  display: flex;
  
`

const Icon = styled.svg`
  fill: none;
  stroke: #CC6F4C;
  stroke-width: 2px;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 28px;
  height: 28px;
  box-shadow: 0 4px 32px 0 #00000012;
  border: 1px solid #605D5C;
  border-radius: 3px;
  background: #fff;
  transition: all 150ms;
  cursor: pointer;
  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')}
  }
`



const SimpleCheckbox = ({ checked, onChange }) => {
    const handleCheckbox = (e) => {
        onChange(e.target.checked)
    }
    return (
        <label>
            <CheckboxContainer >
                <HiddenCheckbox checked={checked} onChange={(e) => handleCheckbox(e)} />
                <StyledCheckbox checked={checked}>
                    <Icon viewBox="0 0 24 24">
                        <polyline points="20 6 9 17 4 12" />
                    </Icon>
                </StyledCheckbox>
            </CheckboxContainer>
        </label>
    )
}


export default SimpleCheckbox
